import { Endpoint } from "shared/utils/endpoints";
import { getQueryforFilters } from "shared/utils/helper";
import { HTTP_CLIENT } from "shared/utils/interceptor";

interface ListingProps {
  search: string;
  sortBy?: string;
  order?: string;
  pageNo: number;
  filter?: string;
}

const AddEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.evaluations.addEvaluation, payload);
};

const CheckJobCodeService = (payload: { jobCode: string }) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.checkJobCode + `?jobCode=${payload?.jobCode}`
  );
};

const AddDraftEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.evaluations.addDraftEvaluation, payload);
};

const UpdateDraftEvaluationsService = (payload: any, id: string) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.updateDraftEvaluation.replace(":id", id),
    payload
  );
};

const GetAllEvaluationsService = (payload: ListingProps) => {
  let query = `?search=${payload?.search}&pageNo=${payload.pageNo}${
    payload?.sortBy && payload?.order
      ? `&sortBy=${payload.sortBy}&order=${payload.order}`
      : ""
  }`;
  if (payload.filter) {
    query += getQueryforFilters(payload);
  }
  return HTTP_CLIENT.get(Endpoint.evaluations.getAllEvaluation + query);
};

const ActivateEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.activateEvaluation.replace(":id", payload?.id)
  );
};

const DeActivateEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.deActivateEvaluation.replace(":id", payload?.id)
  );
};

const ActivateEvaluationVerionService = (payload: any) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.activateEvaluationVersion.replace(":id", payload?.id)
  );
};

const ArchiveEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.put(Endpoint.evaluations.archiveVersion, payload);
};

const UnArchiveEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.put(Endpoint.evaluations.unArchiveVersion, payload);
};

const FlagEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.flagEvaluations.replace(":id", payload?.id)
  );
};

const UnFlagEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.unFlagEvaluations.replace(":id", payload?.id)
  );
};

const GetDraftEvaluationsService = (payload: ListingProps) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getDraftEvaluations +
      `?search=${payload?.search}&pageNo=${payload.pageNo}${
        payload?.sortBy && payload?.order
          ? `&sortBy=${payload.sortBy}&order=${payload.order}`
          : ""
      }`
  );
};

const GetFlagEvaluationsService = (payload: ListingProps) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getFlagEvaluations +
      `?search=${payload?.search}&pageNo=${payload.pageNo}${
        payload?.sortBy && payload?.order
          ? `&sortBy=${payload.sortBy}&order=${payload.order}`
          : ""
      }`
  );
};

const GetCGPEvaluationsService = (payload: ListingProps) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getCGPEvaluations +
      `?search=${payload?.search}&pageNo=${payload.pageNo}${
        payload?.sortBy && payload?.order
          ? `&sortBy=${payload.sortBy}&order=${payload.order}`
          : ""
      }`
  );
};

const AddEvaluationRequestService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.evaluations.addRequest, payload);
};

const GetArchivedEvaluationsService = (payload: ListingProps) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getArchivedEvaluations +
      `?search=${payload?.search}&pageNo=${payload.pageNo}${
        payload?.sortBy && payload?.order
          ? `&sortBy=${payload.sortBy}&order=${payload.order}`
          : ""
      }`
  );
};

const GetSingleEvaluationVersionsService = (payload: {
  search: string;
  id: string;
  filter?: any;
}) => {
  let query = `?search=${payload?.search}`;
  if (payload.filter) {
    query += getQueryforFilters(payload);
  }
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getSingleEvaluation.replace(":id", payload.id) + query
  );
};

const DeleteEvaluationVersiontService = (payload: any) => {
  return HTTP_CLIENT.delete(
    Endpoint.evaluations.deleteEvaluationVersion.replace(":id", payload?.id)
  );
};

const GetCurrentEvaluationVersionDetailService = (payload: { id: string }) => {
  return HTTP_CLIENT.get(
    Endpoint.evaluations.getCurrentVersionDetails.replace(":id", payload?.id)
  );
};

const ApproveEvaluationService = (payload: any) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.approveEvaluation.replace(":id", payload?.id)
  );
};

const UpdateEvaluationService = (payload: any, id: string) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.updateEvaluation.replace(":id", id),
    payload
  );
};

const CompleteDraftEvaluationService = (payload: any, id: string) => {
  return HTTP_CLIENT.put(
    Endpoint.evaluations.completeDraft.replace(":id", id),
    payload
  );
};

const GetArchiveCountService = () => {
  return HTTP_CLIENT.get(Endpoint.evaluations.archiveCount);
};

const DownloadEvaluationsService = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.evaluations.download, payload);
};

const DownloadAllEvaluationsService = (payload: ListingProps) => {
  let query = `?search=${payload?.search}&pageNo=${payload.pageNo}${
    payload?.sortBy && payload?.order
      ? `&sortBy=${payload.sortBy}&order=${payload.order}`
      : ""
  }`;
  if (payload.filter) {
    query += getQueryforFilters(payload);
  }
  return HTTP_CLIENT.post(Endpoint.evaluations.downloadAll + query);
};

export {
  AddEvaluationsService,
  CheckJobCodeService,
  AddDraftEvaluationsService,
  GetAllEvaluationsService,
  ActivateEvaluationsService,
  DeActivateEvaluationsService,
  ActivateEvaluationVerionService,
  ArchiveEvaluationsService,
  UnArchiveEvaluationsService,
  FlagEvaluationsService,
  UnFlagEvaluationsService,
  GetDraftEvaluationsService,
  GetFlagEvaluationsService,
  GetCGPEvaluationsService,
  AddEvaluationRequestService,
  GetArchivedEvaluationsService,
  GetSingleEvaluationVersionsService,
  DeleteEvaluationVersiontService,
  GetCurrentEvaluationVersionDetailService,
  ApproveEvaluationService,
  UpdateEvaluationService,
  CompleteDraftEvaluationService,
  GetArchiveCountService,
  UpdateDraftEvaluationsService,
  DownloadEvaluationsService,
  DownloadAllEvaluationsService,
};
